export default {
  personal: {
    is: 'Netbanki einstaklinga',
    en: 'Personal online banking',
  },
  corporate: {
    is: 'Netbanki fyrirtækja',
    en: 'Corporate online banking',
  },
  language: {
    is: 'English',
    en: 'Íslenska',
  },
};
